var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "importLibrary" },
    [
      _c(
        "VueDraggable",
        {
          staticClass: "list",
          attrs: {
            "chosen-class": "active",
            "drag-class": "drag",
            handle: ".libraryPhoto",
            tag: "ul",
            direction: "horizontal",
            disabled: !_vm.sortActive,
          },
          model: {
            value: _vm.photoModels,
            callback: function ($$v) {
              _vm.photoModels = $$v
            },
            expression: "photoModels",
          },
        },
        [
          _vm._l(_vm.photoModels, function (photoModel) {
            return _c("ImportLibraryItemView", {
              key: photoModel.id,
              class: [
                "listItem",
                "libraryPhoto",
                { disableAnimation: !_vm.sortActive },
              ],
              style: {
                "animation-delay": "-" + _vm.getRandomArbitrary(0, 0.7) + "s",
                "animation-duration": _vm.getRandomArbitrary(0.2, 0.4) + "s",
              },
              attrs: {
                "page-objects": _vm.pageObjects,
                "photo-model": photoModel,
                "has-remove": _vm.sortActive && _vm.importModus,
                "show-included-status": !_vm.importModus,
              },
              on: { clickItem: _vm.clickItem },
            })
          }),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "listItem addPhotos",
              attrs: { slot: "header" },
              on: { click: _vm.addMorePhotos },
              slot: "header",
            },
            [
              _c("div", { staticClass: "icon" }, [
                _c("i", { staticClass: "material-icons mainIcon" }, [
                  _vm._v("\n\t\t\t\t\tphoto_library\n\t\t\t\t"),
                ]),
                _vm._v(" "),
                _c("i", { staticClass: "material-icons extraIcon" }, [
                  _vm._v("\n\t\t\t\t\tadd\n\t\t\t\t"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _c("span", { staticClass: "subscript" }, [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("buttonAddPhotos")) +
                      "\n\t\t\t\t"
                  ),
                ]),
              ]),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }